import { ContentMap } from '../../types';
import { angkorTemplesContent } from './angkor-temples';
import { cambodiaVisaContent } from './cambodia-visa';
import { generalCambodiaContent } from './general-cambodia';
import { phnomPenhRoyalPalaceContent } from './phnom-penh-royal-palace';
import { relatedArticlesSlugsMap } from './relatedArticlesSlugsMap';

export const cambodiaArticlesContentMap: ContentMap = {
  'general-cambodia': generalCambodiaContent,
  'cambodia-visa': cambodiaVisaContent,
  'angkor-temples': angkorTemplesContent,
  'phnom-penh-royal-palace': phnomPenhRoyalPalaceContent,
};

export const cambodiaArticlesCardData = [
  {
    title: 'קמבודיה - תעודת זהות',
    description:
      'מדינה מרתקת בלב דרום-מזרח אסיה שמציעה שילוב מהפנט של מקדשים עתיקים, טבע פראי, תרבות עשירה והיסטוריה עוצמתית – חוויה אותנטית לכל מטייל',
    imageUrl: 'https://tinyurl.com/general-cambodia-preview',
    date: '15.03.2024',
    readTime: '20',
    slug: 'general-cambodia',
  },
  {
    title: 'ויזה לקמבודיה – כל מה שצריך לדעת לקראת הנחיתה!',
    description:
      'כניסה לקמבודיה לבעלי דרכון ישראלי מחייבת ויזה – תהליך פשוט ומהיר עם אפשרות ל-eVisa מראש או ויזה בהגעה, לפי הנוחות והגמישות שלכם',
    imageUrl: '/images/cambodia-old/cambodia-visa/cambodia-visa-preview.png',
    date: '15.03.2024',
    readTime: '12',
    slug: 'cambodia-visa',
  },
  {
    title: 'מקדשי אנגקור – הפלא הארכיאולוגי של קמבודיה',
    description:
      "עיר מקדשים עוצרת נשימה בלב הג'ונגל, שמשלבת פאר אדריכלי, היסטוריה עשירה ורוחניות בתפאורה מרהיבה ובלתי נשכחת",
    imageUrl: 'https://tinyurl.com/angkor-temple-preview',
    date: '15.03.2024',
    readTime: '15',
    slug: 'angkor-temples',
  },
  {
    title: 'מתחם הארמון המלכותי בפנום פן',
    description:
      'מתחם מלכותי מרהיב בלב פנום פן שמשלב היסטוריה, ארכיטקטורה קמבודית מרשימה, גנים פסטורליים ופגודת כסף ייחודית – חוויה בלתי נשכחת בלב הבירה',
    imageUrl: 'https://tinyurl.com/phnom-penh-palace-preview',
    date: '15.03.2024',
    readTime: '12',
    slug: 'phnom-penh-royal-palace',
  },
].map((article) => ({
  ...article,
  articleLink: `/international/cambodia/article/${article.slug}`,
  relatedArticlesSlugs:
    relatedArticlesSlugsMap[
      article.slug as keyof typeof relatedArticlesSlugsMap
    ],
}));
